import axios from 'axios';
import { z } from 'zod';

const backendErrorEnvelopeSchema = z.object({
    messages: z.array(z.object({ message: z.string() })).min(1),
});

export const extractBackendErrorMessage = (error: unknown): string | undefined => {
    if (!axios.isAxiosError(error)) {
        return undefined;
    }
    const parsed = backendErrorEnvelopeSchema.safeParse(error.response?.data);
    return parsed.success ? parsed.data.messages[0].message : undefined;
};
